import React, { ReactElement } from 'react';
import { Button } from 'antd';

import { useContractState } from 'pricing/components/contract/useContractState/useContractState';
import { testId } from 'pricing/utilities/test/dataTestId';
import { ContractTerm } from 'pricing/types';

interface Props {
  contractTerm: ContractTerm;
}

function EditContractTerm(props: Props): ReactElement {
  const { contractTerm } = props;
  const { dispatch } = useContractState();

  const handleEditContractTerm = () => {
    dispatch({
      type: 'SET_EDIT_TERM',
      editContractTerm: contractTerm,
    });
    dispatch({
      type: 'SET_TERMS_FORM_VISIBLE',
      termsFormVisible: true,
    });
  };

  return (
    <Button
      data-testid={testId.editContractTerm}
      onClick={handleEditContractTerm}
      type="link"
      size="small"
    >
      Edit
    </Button>
  );
}

export default EditContractTerm;
